// extracted by mini-css-extract-plugin
export default {"cta":"uF-z","disabled":"vF-z"};